import { render, staticRenderFns } from "./FormServer1Streamax.vue?vue&type=template&id=2b351acd&scoped=true&"
import script from "./FormServer1Streamax.vue?vue&type=script&lang=ts&"
export * from "./FormServer1Streamax.vue?vue&type=script&lang=ts&"
import style0 from "./FormServer1Streamax.vue?vue&type=style&index=0&id=2b351acd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b351acd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2b351acd', component.options)
    } else {
      api.reload('2b351acd', component.options)
    }
    module.hot.accept("./FormServer1Streamax.vue?vue&type=template&id=2b351acd&scoped=true&", function () {
      api.rerender('2b351acd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConfiguracionCamaras/Streamax/Network/ServerStreamax/FormServer1Streamax.vue"
export default component.exports